<template>
  <v-dialog
    v-model="showModuleModal"
    :scrollable="true"
    max-width="900px "
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="headline">
          <v-icon class="mr-2">fa fa-book</v-icon>
          {{ title.title }}
        </span>
      </v-card-title>

      <v-card-text>
        <div class="kt-portlet__head-group d-flex flex-wrap justify-end">
          <v-btn
            color="primary"
            dark
            depressed
            @click="exportData()"
            text
            class="mt-3 mt-md-0 mx-1"
          >
            <v-icon left>fal fa-file-export</v-icon>
            Export Data
          </v-btn>

          <v-snackbar :timeout="0" v-model="warningDialog">
            Progress Report is exporting. Please wait!
            <v-progress-circular
              :size="20"
              class="mx-5"
              color="white"
              indeterminate
            ></v-progress-circular>
          </v-snackbar>
        </div>
        <v-row>
          <v-container>
            <v-tabs v-model="tab" fixed-tabs>
              <v-tab v-for="(tab, index) in tabs" :key="index">
                {{ tab.name }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item v-for="(data, index) in tabs" :key="index">
                <v-data-table
                  :loading="sendLoading"
                  :headers="headers[index]"
                  :items="certificates[data.value]"
                  class="elevation-1 unit-modal__table"
                >
                  <template #item.name="{ item }">
                    <span class="d-flex align-center">
                      <v-tooltip bottom v-if="checkIfHasLink(data, item)">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" x-small
                            >fa fa-question</v-icon
                          >
                        </template>
                        <span>Units were moved to a new series.</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            target="_blank"
                            color="primary"
                            text
                            v-bind="attrs"
                            v-on="on"
                            :disabled="checkIfHasLink(data, item)"
                            @click="
                              gotoModulePage(
                                data.value == 'series' ? item.link_id : item.id,
                                data.link_name
                              )
                            "
                          >
                            {{ item.name == '' ? '(No Name)' : item.name }}
                          </v-btn>
                        </template>
                        <span>View</span>
                      </v-tooltip>
                    </span>
                  </template>
                  <template #item.send_certificates="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          target="_blank"
                          color="primary"
                          text
                          v-bind="attrs"
                          v-on="on"
                          @click="sendCertificate(item)"
                        >
                          send
                          <v-icon x-small class="ml-2"
                            >fal fa-paper-plane</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Re-send Certificate</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue-grey" dark @click="close()"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ModuleModal',

  props: ['value', 'certificates', 'title', 'userId'],

  data() {
    return {
      warningDialog: false,
      sendLoading: false,
      tab: null,
      tabs: [
        {
          name: 'Modules',
          value: 'module',
          link_name: 'CertificationModulePage',
        },
        {
          name: 'Series',
          value: 'series',
          link_name: 'UnitPage',
        },
        {
          name: 'Assigned Playlist',
          value: 'playlist',
          link_name: 'Playlist',
        },
      ],
      headers: [
        [
          {
            text: 'Name',
            tooltip: 'Name of Module',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          {
            text: 'Course',
            align: 'center',
            sortable: true,
            value: 'course',
          },
          {
            text: 'No of Units',
            align: 'center',
            sortable: true,
            value: 'no_units',
          },
          {
            text: 'Send Certificate',
            align: 'center',
            sortable: true,
            value: 'send_certificates',
          },
        ],
        [
          {
            text: 'Name',
            tooltip: 'Name of Series',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          {
            text: 'Module',
            align: 'center',
            sortable: true,
            value: 'module',
          },
          {
            text: 'No of Units',
            align: 'center',
            sortable: true,
            value: 'no_units',
          },
          {
            text: 'Send Certificate',
            align: 'center',
            sortable: true,
            value: 'send_certificates',
          },
        ],
        [
          {
            text: 'Name',
            tooltip: 'Name of Assigned Playlist',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          {
            text: 'Assigned by',
            align: 'center',
            sortable: true,
            value: 'assignedby',
          },
          {
            text: 'No of Units',
            align: 'center',
            sortable: true,
            value: 'no_units',
          },
          {
            text: 'Send Certificate',
            align: 'center',
            sortable: true,
            value: 'send_certificates',
          },
        ],
      ],
    };
  },
  computed: {
    showModuleModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    checkIfHasLink(data, item) {
      if (data.value == 'series') {
        if (item.link_id) {
          return false;
        }
        return true;
      }
      return false;
    },
    gotoModulePage(id, link_name) {
      if (!id) {
        return false;
      }

      let routeData = this.$router.resolve({
        name: link_name,
        params: { id: id },
      });
      window.open(routeData.href, '_blank');
    },
    sendCertificate(data) {
      this.sendLoading = true;
      let params = {
        id: data.id,
        type: data.type,
        userId: this.userId,
      };
      this.$http
        .put('/client/reports/lms/progress/send-certificate', params)
        .then((data) => {
          this.$notify('success', 'Successfully Sent');
          this.sendLoading = false;
        });
    },
    close() {
      this.showModuleModal = false;
      this.$http.delete('/client/reports/lms/progress/show/destroy-cache/', {
        params: {
          id: this.userId,
          value: this.title.value,
        },
      });
    },
    exportData() {
      this.warningDialog = true;
      this.$http
        .get('/client/reports/lms/progress/show/export-cache/', {
          params: {
            id: this.userId,
            value: this.title.value,
          },
        })
        .then((data) => {
          window.location.assign(data.data);

          setTimeout(() => {
            this.warningDialog = false;
          }, 5000);
        });
    },
  },
};
</script>
<style lang="stylus">
.unit-modal__table
  width 100%

.v-tab
  white-space unset !important
</style>
